// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"c6a32fe2","334":"7c6f2cd3","591":"9b5ecfa9"}[chunkId] + ".chunk.js";
};